export default {"src":"/_next/static/media/Equifax.0f97663b.svg","height":60,"width":60};